const LUCRIS_SUBSCRIPTION_ITEM = {
  item_id: "lucris_subscription",
  item_name: "Lucris subscription",
  quantity: 1,
};

/**
 * Sends an event through the Google tag already configured in index.html.
 * Analytics must never interrupt the product flow, so an unavailable tag is
 * treated as a no-op.
 */
export const trackGoogleAnalyticsEvent = (eventName, parameters = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  window.gtag("event", eventName, parameters);
  return true;
};

export const trackSignUp = (method = "unknown") =>
  trackGoogleAnalyticsEvent("sign_up", { method });

export const trackPaymentMethodAdded = () =>
  trackGoogleAnalyticsEvent("add_payment_info", {
    currency: "USD",
    payment_type: "card",
    items: [LUCRIS_SUBSCRIPTION_ITEM],
  });
